import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function CheckedIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    fill: "none",
    viewBox: "0 0 12 12",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M0 6.646l4.286 4.285L12 3.217 10.791 2 4.286 8.506 1.209 5.437 0 6.646z"
    })
  });
}
export default CheckedIcon;